import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles } from './Style/globalStyles'
import { useDarkMode } from './Style/useDarkMode'
import { lightTheme, darkTheme } from './Themes'
import PropTypes from 'prop-types'
import Brightness4Icon from '@material-ui/icons/Brightness4'

const Toggle = ({ toggleTheme }) => {
  return <Brightness4Icon fontSize="small" onClick={toggleTheme} />
}
Toggle.propTypes = {
  // theme: PropTypes.string,
  toggleTheme: PropTypes.func.isRequired
}
Toggle.displayName = 't'

const Theme = () => {
  const [theme, themeToggler] = useDarkMode()
  const themeMode = theme === 'dark' ? darkTheme : lightTheme

  useEffect(() => {
    // const timer = setTimeout(() => {}, 1)
    // return () => clearTimeout(timer)
  }, [theme])
  // if (!mountedComponent) return <div />;
  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <Toggle toggleTheme={themeToggler} />
    </ThemeProvider>
  )
}

export default Theme
